export default {
  SET_AUDIO(state, audio) {
    state.audio = audio || null;
  },
  SET_VIDEO(state, video) {
    state.video = video || null;
  },
  SET_LOADING(state, value) {
    state.isLoading = !!value;
  },
  CLEAR(state) {
    state.audio = null;
    state.video = null;
    state.isLoading = false;
  },
};
